import React from "react";
import { Page, PageTitle } from "components/ui/Page";
import { Layout } from "components/ui/Layout";
import { UIDSlateErrorCard } from "components/cards/UIDSlateErrorCard";

export function UIDSlateErrorPage() {
  return (
    <Layout>
      <Page>
        <PageTitle title="Problems with CalNet Login" />
        <UIDSlateErrorCard />
      </Page>
    </Layout>
  );
}
